import { ReducersRegistry } from '@grandvisionhq/state';
import shippingReducer from './state/reducer.js';
import * as index from './operations/index.js';
export { index as Operations };
export { defaultDeliveryResolver } from './utils/default-delivery-resolver.js';
export { DeliveryIndicator } from './modules/DeliveryIndicator/layout/DeliveryIndicator.js';
export { useGetEstimatedDeliveryMessage } from './hooks/use-get-estimated-delivery-message.js';
export { useGetDispatchDate } from './hooks/use-get-dispatch-date.js';
export { useGetShippingMethods } from './hooks/use-get-shipping-methods.js';
export { useDeliveryIndicator, withDeliveryIndicator } from './contexts/DeliveryIndicator/context.js';
export { DeliveryIndicatorProvider } from './contexts/DeliveryIndicator/provider.js';
export { setPreferredShippingMethod } from './state/actions.js';
export { getPreferredShippingMethod } from './state/selectors.js';

ReducersRegistry.register('shipping', shippingReducer);
//# sourceMappingURL=index.js.map
